export function EmojiExpressionlessIcon({ size = 16 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 3.63636C17.8511 3.63636 15.7232 4.05962 13.7379 4.88197C11.7526 5.70432 9.94867 6.90966 8.42916 8.42916C6.90966 9.94867 5.70432 11.7526 4.88197 13.7379C4.05962 15.7232 3.63636 17.8511 3.63636 20C3.63636 22.1489 4.05962 24.2768 4.88197 26.2621C5.70432 28.2474 6.90966 30.0513 8.42916 31.5708C9.94867 33.0903 11.7526 34.2957 13.7379 35.118C15.7232 35.9404 17.8511 36.3636 20 36.3636C24.3399 36.3636 28.5021 34.6396 31.5708 31.5708C34.6396 28.5021 36.3636 24.3399 36.3636 20C36.3636 15.6601 34.6396 11.4979 31.5708 8.42916C28.5021 5.36038 24.3399 3.63636 20 3.63636ZM0 20C0 8.95455 8.95455 0 20 0C31.0455 0 40 8.95455 40 20C40 31.0455 31.0455 40 20 40C8.95455 40 0 31.0455 0 20ZM14.5455 12.7273V20H10.9091V12.7273H14.5455ZM29.0909 12.7273V20H25.4545V12.7273H29.0909ZM12.7273 23.6364H27.2727V27.2727H12.7273V23.6364Z"
        fill="currentColor"
      />
    </svg>
  );
}
